import "./App.css";
import { useState } from "react";

import PageAlarm from "components/PageAlarm";
import PageLoading from "components/PageLoading";
import PageReport from "components/PageReport";
import PageUser from "components/PageUser";
import PopupChatbot from "components/PopupChatbot";
import Dashboard from "components/PageDashboard";

import { HomeyApiContext } from "lib/HomeyApiContext";

function App() {
  const [userInfo, setUserInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [homeyApi, setHomeyApi] = useState(null);

  return (
    <HomeyApiContext.Provider value={{ homeyApi, setHomeyApi }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          height: "100vh",
          fontFamily: "NoonnuBasicGothicRegular",
          background: "#f9f9f9",
        }}
      >
        {isLoading && <PageLoading />}

        {/* 챗봇 */}
        {userInfo && <PopupChatbot />}

        {/* 좌측 영역 */}
        <div
          style={{
            flex: 1,
            margin: "1rem",
            display: "flex",
            flexDirection: "column",
            overflowX: "auto",
          }}
        >
          <PageUser
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            setIsLoading={setIsLoading}
          />
          <Dashboard userInfo={userInfo} />
          <PageReport userInfo={userInfo} />
        </div>

        {/* 우측 영역 */}
        <PageAlarm userInfo={userInfo} />
      </div>
    </HomeyApiContext.Provider>
  );
}

export default App;
